import IconButton from "../../ui/buttons/IconButton";
import { ReactComponent as TrashIcon } from "../../assets/icons/trash.svg";

import styles from "../../styles/components/leads/LeadStageCard.module.css";

export default function LeadStageCard({
  id,
  name,
  company,
  contactName,
  contactRole,
  onDelete,
}) {
  const contactText = [contactName, contactRole].filter(Boolean).join(", ");

  return (
    <article className={styles.card}>
      <div className={styles.idBadge}>
        <span className={styles.idText}>#{id}</span>
      </div>

      <div className={styles.content}>
        <div className={styles.titleRow}>
          <h3 className={styles.title}>{name}</h3>

          {company ? (
            <span className={styles.companyPill}>{company}</span>
          ) : null}

          {onDelete ? (
            <IconButton
              icon={<TrashIcon className={styles.trashIcon} />}
              iconSize={18}
              size="sm"
              tone="danger"
              onClick={onDelete}
              aria-label="Eliminar lead"
              title="Eliminar lead"
            />
          ) : null}
        </div>

        {contactText ? (
          <p className={styles.subtitle}>{contactText}</p>
        ) : null}
      </div>
    </article>
  );
}
